import type { Runtime } from "@baton/core";
import { createContext, useContext, type ReactNode } from "react";

/**
 * The one runtime of `@baton/core` (`createRuntime` in `main.tsx`), reachable from every
 * authenticated screen through context. Context carries it because it never changes during
 * a session, which is the one use `research.md` W-05 admits for context.
 */
const RuntimeContext = createContext<Runtime | null>(null);

export function RuntimeProvider({ runtime, children }: { readonly runtime: Runtime; readonly children: ReactNode }) {
  return <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>;
}

export function useRuntime(): Runtime {
  const value = useContext(RuntimeContext);
  if (value === null) throw new Error("useRuntime must be used inside <RuntimeProvider>");
  return value;
}
